import { useGetAllCountriesQuery } from 'generated/graphql'
import { ControlledSelect } from 'components/ControlledFields'
import { CountryFlag } from 'components/CountryFlag'
import { FieldValues, FieldPath } from 'react-hook-form'
import { ICustomFieldComponentProps } from 'types'

type CountrySingleSelectProps<T extends FieldValues> =
  ICustomFieldComponentProps<T, FieldPath<T>>

export const CountrySingleSelect = <T extends FieldValues>({
  name,
  label,
  placeholder,
  disabled
}: CountrySingleSelectProps<T>) => {
  const { data, loading } = useGetAllCountriesQuery()

  const options =
    data?.countries?.map(country => ({
      value: country.alpha2,
      label: (
        <span className="flex items-center gap-2">
          <CountryFlag alpha2={country.alpha2} />
          {country.name}
        </span>
      ),
      searchLabel: country.name
    })) ?? []

  return (
    <ControlledSelect
      name={name}
      label={label}
      options={options}
      placeholder={placeholder}
      disabled={disabled}
      isLoading={loading}
    />
  )
}
